

type filetype = 'excel' | 'xlsx' | 'pdf' | 'csv' | 'doc' | 'zip'

export const generateDownload = (file: any, fileName: string, type: filetype, open?: boolean): void => {
  const url = window.URL.createObjectURL(
    new Blob([file], { type: getType(type) })
  );
  const link = document.createElement("a");
  link.href = url;

  if (open) {
    const win = window.open("", "_blank");
    if (win) {
      win.document.title = `${fileName}.${type}`;
      win.document.body.innerHTML = `
  <iframe
    src="${url}"
    style="width:100%;height:100vh;border:none">
  </iframe>
`;
    }
  }

  else
    link.setAttribute("download", `${fileName}.${type}`);

  document.body.appendChild(link);
  if (!open)
    link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};



const getType = (type: filetype) => {

  switch (type) {
    case "excel":
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

    case "csv":
      return "text/csv"

    case "doc":
      return "application/msword"

    case "zip":
      return "application/zip"

    default:
      return "application/pdf"
  }

}